import React from 'react';
import { ElmoSortIcon } from '../../Icon';
function SortButton() {
    return React.createElement(ElmoSortIcon, { className: "elmo-sort__button " });
}
export default SortButton;
